import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardMarchandComponent } from './dashboard-marchand/dashboard-marchand.component';
import { HeaderMarchandComponent } from './header-marchand/header-marchand.component';
import { TabViewMarchandComponent } from './tab-view-marchand/tab-view-marchand.component';
import { TabViewModule } from 'primeng/tabview';
import { Angular2SmartTableModule } from 'angular2-smart-table';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { RouterModule } from '@angular/router';
import { SideBarMarchandComponent } from 'src/app/side-bar-marchand/side-bar-marchand.component';
import { SoldesComponent } from './soldes/soldes.component';
import { RemboursementsComponent } from './remboursements/remboursements.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { QrCodeComponent } from './qr-code/qr-code.component';
import { ProfilMarchandComponent } from './profil/profil.component';
import { EmployeModule } from '../employe/employe.module';
import { AideComponent } from './aide/aide.component';
import { KidsComponent } from './kids/kids.component';
import { BonsComponent } from './bons/bons.component';
import {ConfirmDialogModule} from "primeng/confirmdialog";


@NgModule({
  declarations: [
    DashboardMarchandComponent,
    HeaderMarchandComponent,
    TabViewMarchandComponent,
    SideBarMarchandComponent,
    SoldesComponent,
    RemboursementsComponent,
    TransactionsComponent,
    QrCodeComponent,
    KidsComponent,
    BonsComponent,
    ProfilMarchandComponent,
    AideComponent
  ],
  imports: [
    CommonModule,
    TabViewModule,
    Angular2SmartTableModule,
    CardModule,
    DialogModule,
    ButtonModule,
    InputTextModule,
    BrowserAnimationsModule,
    InputSwitchModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    RippleModule,
    ToastModule,
    RouterModule,
    EmployeModule,
    ConfirmDialogModule
  ],
  exports: [
    DashboardMarchandComponent,
    SideBarMarchandComponent,
    TabViewMarchandComponent,
  ],
})
export class MarchandModule {}
